export { Dashboard as DashboardLayout } from './Dashboard';
